export const videoData = [
  {
    id: 1,
    title: "长安十二时辰",
    slug: "changan-twelve-hours",
    category: "电视剧",
    source: "香蕉视频",
    rating: 9.1,
    year: 2024,
    description: "唐朝天宝三年，上元节前夕，长安城陷入一场惊天阴谋。死囚张小敬临危受命，与靖安司司丞李必携手在十二时辰内拯救长安城。",
    longDescription: "《长安十二时辰》改编自马伯庸同名小说，讲述了唐朝天宝三年上元节前夕，长安城混入可疑人员，身陷囹圄的张小敬临危受命，与少年天才李必携手在十二时辰内破除隐患、拯救长安的故事。全剧以精良的制作、紧张的剧情和深厚的文化底蕴获得观众一致好评。",
    image: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20dynasty%20drama%20poster%20with%20warrior%20in%20Tang%20dynasty%20armor%20standing%20on%20ancient%20city%20wall%20at%20night%2C%20dramatic%20lighting%2C%20cinematic%20film%20poster%20style%2C%20warm%20golden%20and%20red%20tones%2C%20epic%20atmosphere%2C%20clean%20composition&width=600&height=800&seq=video-card-01&orientation=portrait",
    episodes: 48,
    tags: ["古装", "悬疑", "历史", "剧情"],
    updateTime: "2024-07-28",
    featured: true,
  },
  {
    id: 2,
    title: "繁花",
    slug: "fan-hua",
    category: "电视剧",
    source: "糖豆视频",
    rating: 9.3,
    year: 2024,
    description: "九十年代的上海，阿宝凭借改革开放的春风，从平凡青年成长为商界后起之秀。在沪上弄潮儿女中留下一段传奇故事。",
    longDescription: "《繁花》改编自金宇澄同名小说，由王家卫执导，胡歌、马伊琍、唐嫣、辛芷蕾主演。讲述了九十年代初的上海，人人争上游，阿宝也变成了宝总，成功过，失败过，在沪上弄潮儿女中留下一段传奇。",
    image: "https://readdy.ai/api/search-image?query=1990s%20Shanghai%20nostalgic%20drama%20poster%20with%20elegant%20man%20in%20suit%20walking%20through%20neon%20lit%20street%20at%20night%2C%20warm%20golden%20glow%2C%20cinematic%20film%20poster%20style%2C%20vintage%20aesthetic%2C%20romantic%20atmosphere&width=600&height=800&seq=video-card-02&orientation=portrait",
    episodes: 30,
    tags: ["都市", "年代", "商战", "爱情"],
    updateTime: "2024-07-25",
    featured: true,
  },
  {
    id: 3,
    title: "狂飙",
    slug: "kuang-biao",
    category: "电视剧",
    source: "小蓝视频",
    rating: 9.5,
    year: 2024,
    description: "京海市一线刑警安欣与黑恶势力展开了长达二十年的生死搏斗，最终在全国政法队伍教育整顿中彻底铲除盘踞多年的犯罪集团。",
    longDescription: "《狂飙》讲述了以一线刑警安欣为代表的正义力量，与以高启强为首的黑恶势力展开的长达二十年的生死较量。通过群像叙事，展现扫黑行动中的黑白较量与复杂人性。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%20with%20two%20men%20facing%20each%20other%20in%20dramatic%20tension%2C%20dark%20urban%20cityscape%20background%2C%20cinematic%20lighting%2C%20film%20noir%20style%2C%20intense%20mood%2C%20warm%20contrast%20tones&width=600&height=800&seq=video-card-03&orientation=portrait",
    episodes: 39,
    tags: ["犯罪", "剧情", "扫黑", "悬疑"],
    updateTime: "2024-07-20",
    featured: true,
  },
  {
    id: 4,
    title: "流浪地球3",
    slug: "wandering-earth-3",
    category: "电影",
    source: "蓝莓视频",
    rating: 8.8,
    year: 2025,
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，年轻一代挺身而出展开生死之战。",
    longDescription: "《流浪地球3》延续前作世界观，在地球流浪旅程进入全新阶段后，人类面临更加严峻的生存挑战。新一代航天员和科学家们必须在危机中寻找希望，展开一场关乎人类命运的终极之战。",
    image: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20with%20giant%20planet%20engines%20on%20frozen%20earth%20surface%2C%20astronaut%20standing%20in%20foreground%2C%20dramatic%20space%20background%20with%20stars%2C%20cinematic%20film%20poster%2C%20warm%20orange%20and%20cool%20blue%20contrast&width=600&height=800&seq=video-card-04&orientation=portrait",
    episodes: 1,
    tags: ["科幻", "灾难", "冒险", "国产大片"],
    updateTime: "2025-01-15",
    featured: true,
  },
  {
    id: 5,
    title: "庆余年第二季",
    slug: "qing-yu-nian-2",
    category: "电视剧",
    source: "香蕉视频",
    rating: 8.9,
    year: 2024,
    description: "范闲从澹州初入京都，凭借过人的智谋和勇气在庙堂与江湖之间游走，书写了一段波澜壮阔的传奇人生。",
    longDescription: "《庆余年第二季》延续第一季的故事线，范闲在经历了一系列生死考验后，逐渐深入庆国权力核心。面对更加复杂的朝堂斗争和身世之谜，他将如何应对？",
    image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20young%20scholar%20in%20ancient%20Chinese%20robe%20holding%20sword%2C%20palace%20background%2C%20dramatic%20clouds%2C%20cinematic%20style%2C%20warm%20golden%20tones%2C%20epic%20fantasy%20atmosphere&width=600&height=800&seq=video-card-05&orientation=portrait",
    episodes: 36,
    tags: ["古装", "权谋", "武侠", "剧情"],
    updateTime: "2024-06-18",
    featured: false,
  },
  {
    id: 6,
    title: "封神第二部",
    slug: "feng-shen-2",
    category: "电影",
    source: "糖豆视频",
    rating: 8.5,
    year: 2025,
    description: "殷商末年，纣王无道。姬发在姜子牙的辅佐下，率领西岐大军讨伐商朝，一场神魔大战即将爆发。",
    longDescription: "《封神第二部》承接第一部剧情，姬发回到西岐后，在姜子牙的辅佐下举起反商大旗。各方势力纷纷登场，神仙妖魔齐上阵，一场决定天下归属的大战一触即发。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20film%20poster%20with%20ancient%20warriors%20and%20magical%20creatures%20in%20epic%20battle%2C%20dramatic%20sky%20with%20thunder%2C%20cinematic%20style%2C%20warm%20golden%20and%20red%20tones%2C%20epic%20scale&width=600&height=800&seq=video-card-06&orientation=portrait",
    episodes: 1,
    tags: ["奇幻", "神话", "动作", "史诗"],
    updateTime: "2025-02-10",
    featured: false,
  },
  {
    id: 7,
    title: "大奉打更人",
    slug: "da-feng-da-geng-ren",
    category: "电视剧",
    source: "小蓝视频",
    rating: 8.3,
    year: 2024,
    description: "现代警察许七安穿越到大奉王朝，成为一名打更人。在破解一桩桩奇案的过程中，他逐渐揭开了这个世界的惊天秘密。",
    longDescription: "《大奉打更人》改编自卖报小郎君同名小说，讲述现代警察许七安穿越到大奉王朝，凭借超强的推理能力屡破奇案，成为一代传奇打更人的故事。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20drama%20poster%20with%20detective%20in%20ancient%20Chinese%20official%20uniform%2C%20dark%20alleyway%20at%20night%2C%20lanterns%2C%20mysterious%20atmosphere%2C%20cinematic%20film%20poster%2C%20warm%20amber%20lighting&width=600&height=800&seq=video-card-07&orientation=portrait",
    episodes: 40,
    tags: ["古装", "悬疑", "穿越", "探案"],
    updateTime: "2024-05-20",
    featured: false,
  },
  {
    id: 8,
    title: "哪吒之魔童闹海",
    slug: "nezha-2",
    category: "电影",
    source: "蓝莓视频",
    rating: 8.7,
    year: 2025,
    description: "天劫之后，哪吒和敖丙的灵魂虽被保住但面临魂飞魄散。太乙真人决定用七色宝莲为二人重塑肉身，然而过程中困难重重。",
    longDescription: "《哪吒之魔童闹海》延续前作《哪吒之魔童降世》的故事，在哪吒和敖丙经历天劫后，太乙真人用七色宝莲为二人重塑肉身。然而更大的危机正在逼近，哪吒将面临新的考验。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20film%20poster%20with%20mythological%20boy%20warrior%20with%20fire%20wheel%20and%20red%20sash%2C%20dramatic%20sky%20with%20lightning%2C%20cinematic%20animation%20style%2C%20vibrant%20warm%20colors%2C%20epic%20composition&width=600&height=800&seq=video-card-08&orientation=portrait",
    episodes: 1,
    tags: ["动画", "奇幻", "神话", "喜剧"],
    updateTime: "2025-03-01",
    featured: true,
  },
  {
    id: 9,
    title: "玫瑰的故事",
    slug: "rose-story",
    category: "电视剧",
    source: "香蕉视频",
    rating: 8.4,
    year: 2024,
    description: "黄亦玫出生于书香世家，从小展露出艺术天赋。在经历几段感情后，她逐渐成长为一个独立自信的现代女性。",
    longDescription: "《玫瑰的故事》改编自亦舒同名小说，由刘亦菲主演，讲述了女主角黄亦玫跨越二十余年的成长与情感历程，展现了现代女性追求自我价值的动人故事。",
    image: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20modern%20romance%20drama%20poster%20with%20beautiful%20woman%20in%20rose%20garden%2C%20soft%20warm%20lighting%2C%20romantic%20cinematic%20style%2C%20delicate%20pink%20and%20cream%20tones%2C%20dreamy%20atmosphere&width=600&height=800&seq=video-card-09&orientation=portrait",
    episodes: 38,
    tags: ["都市", "爱情", "女性", "成长"],
    updateTime: "2024-04-15",
    featured: false,
  },
  {
    id: 10,
    title: "热辣滚烫",
    slug: "re-la-gun-tang",
    category: "电影",
    source: "糖豆视频",
    rating: 8.2,
    year: 2024,
    description: "乐莹是一个善良的女孩，在经历了生活的各种打击后，她决定通过拳击改变自己，找到了人生新的方向。",
    longDescription: "《热辣滚烫》由贾玲执导并主演，讲述了女主角乐莹在生活低谷中通过拳击运动重新找到自我的励志故事。影片以温暖幽默的方式传递了积极向上的生活态度。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20inspirational%20comedy%20film%20poster%20with%20woman%20in%20boxing%20gloves%20smiling%20confidently%2C%20warm%20gym%20lighting%2C%20cinematic%20style%2C%20energetic%20atmosphere%2C%20golden%20warm%20tones&width=600&height=800&seq=video-card-10&orientation=portrait",
    episodes: 1,
    tags: ["喜剧", "励志", "运动", "剧情"],
    updateTime: "2024-02-10",
    featured: false,
  },
  {
    id: 11,
    title: "与凤行",
    slug: "yu-feng-xing",
    category: "电视剧",
    source: "小蓝视频",
    rating: 8.6,
    year: 2024,
    description: "灵界碧苍王沈璃因逃婚坠落人间，与上古神君行止相遇，两人在凡间展开了一段跨越三界的奇幻爱情故事。",
    longDescription: "《与凤行》改编自九鹭非香小说，由赵丽颖、林更新主演，讲述了灵界碧苍王沈璃与上古神君行止之间跨越人、灵、仙三界的奇幻爱情故事。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%20with%20goddess%20in%20flowing%20red%20dress%20floating%20in%20sky%2C%20ancient%20Chinese%20palace%20background%2C%20magical%20particles%2C%20cinematic%20style%2C%20warm%20ethereal%20lighting&width=600&height=800&seq=video-card-11&orientation=portrait",
    episodes: 40,
    tags: ["古装", "仙侠", "爱情", "奇幻"],
    updateTime: "2024-03-18",
    featured: false,
  },
  {
    id: 12,
    title: "一闪一闪亮星星",
    slug: "twinkling-stars",
    category: "电影",
    source: "蓝莓视频",
    rating: 8.0,
    year: 2024,
    description: "林北星意外回到高中时代，遇见了曾经暗恋的男生张万森。这一次她决定不再错过，勇敢表达自己的心意。",
    longDescription: "《一闪一闪亮星星》讲述了女主角林北星意外穿越回到高中时代，重新遇见曾经暗恋的男生张万森。在一次次穿越中，她逐渐发现两人之间隐藏的秘密，展开了一段温暖治愈的青春故事。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20youth%20romance%20film%20poster%20with%20young%20couple%20under%20starry%20night%20sky%2C%20high%20school%20campus%20background%2C%20warm%20nostalgic%20lighting%2C%20cinematic%20style%2C%20dreamy%20soft%20tones&width=600&height=800&seq=video-card-12&orientation=portrait",
    episodes: 1,
    tags: ["青春", "爱情", "穿越", "治愈"],
    updateTime: "2024-01-01",
    featured: false,
  },
  {
    id: 13,
    title: "南来北往",
    slug: "nan-lai-bei-wang",
    category: "电视剧",
    source: "香蕉视频",
    rating: 8.7,
    year: 2024,
    description: "1978年，青年乘警汪新在火车上结识了老铁路警察马魁。两代人一起守护铁路安全，见证了中国四十年的时代变迁。",
    longDescription: "《南来北往》以铁路乘警的视角，展现了从1978年到2018年四十年间中国社会的巨大变迁。通过火车上的人生百态，讲述了改革开放以来普通人的命运流转。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20with%20train%20conductor%20in%201980s%20uniform%20standing%20beside%20old%20steam%20train%2C%20nostalgic%20golden%20sunset%20light%2C%20cinematic%20film%20poster%2C%20warm%20vintage%20tones&width=600&height=800&seq=video-card-13&orientation=portrait",
    episodes: 39,
    tags: ["年代", "剧情", "铁路", "怀旧"],
    updateTime: "2024-02-25",
    featured: false,
  },
  {
    id: 14,
    title: "第二十条",
    slug: "article-20",
    category: "电影",
    source: "糖豆视频",
    rating: 8.3,
    year: 2024,
    description: "一位检察官在职业生涯中面临道德与法律的抉择。一桩看似简单的案件背后，隐藏着关于正当防卫的复杂法律困境。",
    longDescription: "《第二十条》聚焦《刑法》第二十条关于正当防卫的规定，通过检察官的视角探讨法律与人情的边界。影片以真实案例为蓝本，引发观众对法治社会的深入思考。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20legal%20drama%20film%20poster%20with%20prosecutor%20in%20courtroom%2C%20scales%20of%20justice%20silhouette%2C%20dramatic%20lighting%2C%20cinematic%20style%2C%20serious%20mood%2C%20warm%20dark%20tones&width=600&height=800&seq=video-card-14&orientation=portrait",
    episodes: 1,
    tags: ["剧情", "法律", "社会", "现实"],
    updateTime: "2024-02-10",
    featured: false,
  },
  {
    id: 15,
    title: "狐妖小红娘月红篇",
    slug: "fox-spirit-matchmaker",
    category: "电视剧",
    source: "小蓝视频",
    rating: 7.9,
    year: 2024,
    description: "涂山红红是狐妖一族的首领，她与东方月初之间有着跨越千年的情感羁绊。为了守护人妖两界的和平共同对抗邪恶势力。",
    longDescription: "《狐妖小红娘月红篇》改编自同名热门动漫，讲述了涂山狐妖红红与东方月初之间跨越千年的爱情故事，以及他们为维护人妖两界和平所做的努力。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%20with%20fox%20spirit%20woman%20in%20red%20ancient%20dress%2C%20magical%20forest%20background%2C%20cherry%20blossoms%2C%20ethereal%20lighting%2C%20cinematic%20style%2C%20warm%20pink%20tones&width=600&height=800&seq=video-card-15&orientation=portrait",
    episodes: 36,
    tags: ["古装", "奇幻", "爱情", "动漫改编"],
    updateTime: "2024-05-23",
    featured: false,
  },
  {
    id: 16,
    title: "飞驰人生2",
    slug: "pegasus-2",
    category: "电影",
    source: "蓝莓视频",
    rating: 8.1,
    year: 2024,
    description: "曾经的赛车冠军张驰因伤退役后经营驾校。然而一次偶然机会，他决定重返赛场，再次追逐速度与梦想。",
    longDescription: "《飞驰人生2》由韩寒执导，沈腾主演。讲述曾经的赛车冠军张驰在退役后重燃赛车梦想，克服重重困难再次踏上赛道的故事。影片融合了喜剧与热血赛车元素。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20film%20poster%20with%20race%20car%20driver%20in%20helmet%20standing%20beside%20rally%20car%2C%20desert%20racing%20track%2C%20dramatic%20sunset%20sky%2C%20cinematic%20style%2C%20warm%20golden%20light&width=600&height=800&seq=video-card-16&orientation=portrait",
    episodes: 1,
    tags: ["喜剧", "赛车", "励志", "运动"],
    updateTime: "2024-02-10",
    featured: false,
  },
  {
    id: 17,
    title: "唐朝诡事录之西行",
    slug: "tang-dynasty-mystery",
    category: "电视剧",
    source: "香蕉视频",
    rating: 8.5,
    year: 2024,
    description: "苏无名和卢凌风这对搭档再次出发，沿丝绸之路向西探秘。一路上遭遇各种诡异事件，揭开唐朝盛世背后的神秘面纱。",
    longDescription: "《唐朝诡事录之西行》延续前作风格，讲述苏无名和卢凌风沿丝绸之路向西探秘的冒险故事。一路上离奇案件不断，他们凭借智慧与勇气，揭开层层迷雾。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20drama%20poster%20with%20two%20detectives%20in%20Tang%20dynasty%20robes%20on%20silk%20road%2C%20desert%20landscape%2C%20mysterious%20atmosphere%2C%20cinematic%20style%2C%20warm%20sandy%20tones&width=600&height=800&seq=video-card-17&orientation=portrait",
    episodes: 36,
    tags: ["古装", "悬疑", "探案", "冒险"],
    updateTime: "2024-07-10",
    featured: true,
  },
  {
    id: 18,
    title: "好东西",
    slug: "her-story",
    category: "电影",
    source: "糖豆视频",
    rating: 8.9,
    year: 2024,
    description: "单亲妈妈王铁梅带着女儿搬到新家后，结识了邻居小叶。两个性格迥异的女性在相处中互相温暖，找到了生活的新意义。",
    longDescription: "《好东西》由邵艺辉执导，讲述了单亲妈妈王铁梅与邻居小叶之间从陌生到亲密的故事。影片以细腻的笔触描绘了当代都市女性的生活状态和情感世界。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20contemporary%20drama%20film%20poster%20with%20two%20women%20laughing%20together%20in%20sunlit%20apartment%2C%20warm%20natural%20light%2C%20cinematic%20style%2C%20intimate%20atmosphere%2C%20soft%20cream%20tones&width=600&height=800&seq=video-card-18&orientation=portrait",
    episodes: 1,
    tags: ["剧情", "女性", "都市", "温情"],
    updateTime: "2024-11-22",
    featured: false,
  },
  {
    id: 19,
    title: "三大队",
    slug: "three-brigades",
    category: "电视剧",
    source: "小蓝视频",
    rating: 8.8,
    year: 2024,
    description: "一次追捕行动中，三大队的刑警程兵因意外导致嫌犯死亡而入狱。出狱后他以普通人身份继续追凶，坚持十二年最终将真凶绳之以法。",
    longDescription: "《三大队》改编自真实事件，讲述了刑警程兵在出狱后以普通人的身份继续追查真凶的故事。十二年的坚守，展现了人民警察的执着与信念。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%20with%20former%20police%20officer%20walking%20alone%20on%20rainy%20street%20at%20night%2C%20neon%20reflections%2C%20film%20noir%20style%2C%20cinematic%2C%20warm%20dark%20moody%20tones&width=600&height=800&seq=video-card-19&orientation=portrait",
    episodes: 24,
    tags: ["犯罪", "悬疑", "剧情", "真实改编"],
    updateTime: "2024-06-15",
    featured: false,
  },
  {
    id: 20,
    title: "抓娃娃",
    slug: "successor",
    category: "电影",
    source: "蓝莓视频",
    rating: 8.0,
    year: 2024,
    description: "马成钢和春兰这对超级富豪夫妇为了培养儿子，不惜伪装成贫困家庭。一场啼笑皆非的育儿大作战就此展开。",
    longDescription: '《抓娃娃》由沈腾、马丽主演，讲述了一对富豪夫妇为了不让儿子养成骄奢习气，伪装成贫困家庭进行“穷养”教育的爆笑故事。',
    image: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20film%20poster%20with%20family%20of%20three%20in%20messy%20apartment%20laughing%2C%20bright%20warm%20lighting%2C%20cinematic%20style%2C%20joyful%20chaotic%20atmosphere%2C%20warm%20golden%20tones&width=600&height=800&seq=video-card-20&orientation=portrait",
    episodes: 1,
    tags: ["喜剧", "家庭", "教育", "搞笑"],
    updateTime: "2024-07-16",
    featured: true,
  },
];

export const featuredVideos = videoData.filter(v => v.featured);

export const latestVideos = [...videoData].sort((a, b) =>
  new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()
);

export const topRatedVideos = [...videoData].sort((a, b) => b.rating - a.rating);